<template>
     <Dialog custom-class="dialog-component-main" :close-on-click-modal="closeOnClickModal" :show-close="false" :close-on-press-escape="false"  :visible.sync="dialogValue"  center  v-bind="$attrs" :width="width">
        <div class="dialog-component-container flex-column">
            <div class="dialog-header-container flex-center-center" v-if="title">
                <p>{{title}}</p>
                <div class="dialog-close-container">
                    <slot name="titleRight"></slot>
                    <i class="el-icon-close" @click="handleClose" v-if="showClose"></i>
                </div>
            </div>
            <div class="flex-content-scroll" :style="bodyStyle">
                <slot></slot>
            </div>
            <div class="dialog-footer-container flex-center-center" v-if="$slots.footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </Dialog>
</template>

<script>
import { Dialog } from 'element-ui';
export default {
    components: {
      Dialog
    },
    name: 'ElDialog',
    props: {
        visible: {
            type: Boolean,
            require: true
        },
        title: String,
        width: {
            type: String,
            default: '620px'
        },
        showClose: {
            type: Boolean,
            default: true
        },
        bodyStyle: {
            type: Object,
            default: () => ({padding: '10px'})
        },
        closeOnClickModal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        dialogValue: {
            get() {
                return this.visible
            },
            set(val){
                this.$emit('update:visible',val)
            } 
        }
    },
    methods: {
        handleClose() {
            if(this.$listeners.close) {
                this.$emit('close');
            }else this.dialogValue = false;
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep .dialog-component-main {
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
}
.dialog-component-container {
    height: 100%;
    background: #f6f8f9;
    position: relative;
    .dialog-header-container {
        position: sticky;
        top: 0%;
        width: 100%;
        background: #fff;
        height: 50px;
        box-shadow: 0 1px 2px 0 rgba(100,100,100,.1);
        color: #101214;
        font-weight: 600;
        font-size: 18px;
        z-index: 10;
    }
    .dialog-close-container {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        .el-icon-close {
            font-size: 24px;
            cursor: pointer;
            color: #909399;
        }
    }
    .flex-content-scroll {
        box-shadow: 0 2px 12px 0 rgba(100, 100, 100, .1);
        border-left: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
    }
    .dialog-footer-container {
        position: sticky;
        bottom: 0;
        width: 100%;
        background: #fff;
        min-height: 50px;
        box-shadow: 0 0 2px 0 rgba(100,100,100,.1);
        color: #101214;
        z-index: 10;
    }
}
</style>